export const SortYear = (data: any) => {
    return data.sort((a: any, b: any) => a.year - b.year);
}

export const SortYearDesc = (data: any) => {
    return data.sort((a: any, b: any) => b.year - a.year);
}

export const SortDesc = (data: any) => {
    return data.sort((a: any, b: any) => b - a);
}